import "./DiwaliJhalar.css";

const width = 1200;
const wireY = 10;
const swagDepth = 23;
const swagCount = 6;
const swagWidth = width / swagCount;
const ledColors = [
  { fill: "#ffd84d", glow: "rgba(255, 200, 48, 0.95)" },
  { fill: "#ff9b45", glow: "rgba(255, 132, 48, 0.9)" },
  { fill: "#bd83e6", glow: "rgba(177, 111, 230, 0.9)" },
  { fill: "#ff8cb8", glow: "rgba(255, 121, 174, 0.9)" },
  { fill: "#8fd8ff", glow: "rgba(100, 195, 255, 0.9)" },
  { fill: "#fff4d6", glow: "rgba(255, 240, 202, 0.95)" },
];
const wirePath = Array.from({ length: swagCount }, (_, index) => {
  const startX = index * swagWidth;
  const endX = startX + swagWidth;
  const controlX = startX + swagWidth / 2;
  return `${index === 0 ? `M${startX} ${wireY}` : ""} Q${controlX} ${wireY + swagDepth * 2} ${endX} ${wireY}`;
}).join(" ");

const curveY = (x) => {
  const localX = x % swagWidth;
  const t = localX / swagWidth;
  return wireY + 4 * swagDepth * t * (1 - t);
};

const bulbs = Array.from({ length: 145 }, (_, index) => {
  const x = (index * width) / 144;
  return {
    x,
    y: curveY(x),
    color: ledColors[index % ledColors.length],
    delay: `${((index % 2) * 0.55 + (index * 0.047) % 0.28).toFixed(2)}s`,
  };
});

const lanterns = [
  { x: 100, color: "orange" },
  { x: 200, color: "purple" },
  { x: 400, color: "orange" },
  { x: 500, color: "purple" },
  { x: 700, color: "orange" },
  { x: 800, color: "purple" },
  { x: 1000, color: "orange" },
  { x: 1100, color: "purple" },
];

function Lantern({ x, color }) {
  const y = curveY(x);
  return (
    <g className={`diwali-jhalar-lantern diwali-jhalar-lantern--${color}`} transform={`translate(${x} ${y})`}>
      <path className="diwali-jhalar-hanger" d="M0 0v9" />
      <path className="diwali-jhalar-lantern-cap" d="M-7 9h14l-2 3H-5z" />
      <path className="diwali-jhalar-lantern-body" d="M-5 12h10l-1 9-4 4-4-4z" />
      <path className="diwali-jhalar-lantern-detail" d="M0 13v11M-4 17h8" />
      <path className="diwali-jhalar-lantern-tail" d="M0 25v3" />
    </g>
  );
}

export default function DiwaliJhalar() {
  const diyaX = width / 2;
  const diyaY = curveY(diyaX);

  return (
    <div className="diwali-jhalar" aria-hidden="true">
      <svg className="diwali-jhalar-art" viewBox={`0 0 ${width} 66`} preserveAspectRatio="none">
        <path className="diwali-jhalar-wire" d={wirePath} />
        {bulbs.map(({ x, y, delay, color }, index) => (
          <circle
            key={index}
            className="diwali-jhalar-light"
            cx={x}
            cy={y}
            r="2.3"
            style={{
              "--diwali-jhalar-delay": delay,
              "--diwali-jhalar-led-color": color.fill,
              "--diwali-jhalar-led-glow": color.glow,
            }}
          />
        ))}
        {lanterns.map((lantern) => <Lantern key={lantern.x} {...lantern} />)}
        <g className="diwali-jhalar-diya" transform={`translate(${diyaX} ${diyaY + 1})`}>
          <path className="diwali-jhalar-diya-hanger" d="M0 0v8" />
          <path className="diwali-jhalar-diya-bowl" d="M-11 8h22c-1 6-5 9-11 9S-10 14-11 8Z" />
          <path className="diwali-jhalar-diya-rim" d="M-11 8h22" />
          <path className="diwali-jhalar-diya-flame" d="M0 5c5 5 4 8 0 10-4-2-5-5 0-10Z" />
          <path className="diwali-jhalar-diya-flame-core" d="M0 8c2 3 2 5 0 6-2-1-2-3 0-6Z" />
          <path className="diwali-jhalar-diya-ornament" d="M-5 13q5 4 10 0" />
        </g>
      </svg>
    </div>
  );
}
